import { Button } from "@devhop/ui";
import type { InstructorPayrollBatchSummaryDTO } from "../api/client";
import type { PayoutBatchWorkflowStep } from "../lib/instructor-payout-display";
import { InstructorMonthlyPayoutBatchStepper } from "./InstructorMonthlyPayoutBatchStepper";

type InstructorMonthlyPayoutPayrollBarProps = {
  workflowStep: PayoutBatchWorkflowStep;
  selectionTotals: { sum: number; n: number };
  savedBatch: InstructorPayrollBatchSummaryDTO | null;
  canEditSelection: boolean;
  onSelectAll: (select: boolean) => void;
  onConfirm: () => void;
  onMarkPaid: () => void;
  isConfirmPending: boolean;
  isMarkPaidPending: boolean;
  isLoading: boolean;
};

export function InstructorMonthlyPayoutPayrollBar({
  workflowStep,
  selectionTotals,
  savedBatch,
  canEditSelection,
  onSelectAll,
  onConfirm,
  onMarkPaid,
  isConfirmPending,
  isMarkPaidPending,
  isLoading,
}: InstructorMonthlyPayoutPayrollBarProps) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 px-4 py-3 shadow-[0_-4px_24px_rgba(0,0,0,0.08)] backdrop-blur supports-backdrop-filter:bg-background/85">
      <div className="mx-auto flex max-w-screen-2xl flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0 flex-1">
          <InstructorMonthlyPayoutBatchStepper currentStep={workflowStep} compact />
        </div>

        <div className="flex flex-wrap items-center gap-2 lg:justify-end">
          {canEditSelection ? (
            <>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={() => onSelectAll(true)}
              >
                ເລືອກທັງໝົດ
              </Button>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={() => onSelectAll(false)}
              >
                ລ້າງ
              </Button>
              <span className="text-muted-foreground text-sm tabular-nums">
                {selectionTotals.n} ຄົນ ·{" "}
                {selectionTotals.sum.toLocaleString("lo-LA")} ₭
              </span>
              <Button
                type="button"
                disabled={
                  isLoading ||
                  isConfirmPending ||
                  selectionTotals.n === 0
                }
                onClick={onConfirm}
              >
                {isConfirmPending ? "ກຳລັງບັນທຶກ..." : "ຢືນຢັນບັນທຶກຮອບຄ່າຈ້າງ"}
              </Button>
            </>
          ) : workflowStep === "confirmed" && savedBatch ? (
            <>
              <span className="text-muted-foreground text-sm tabular-nums">
                ບັນທຶກ {savedBatch.instructorCount} ຄົນ ·{" "}
                {savedBatch.totalAmountKip.toLocaleString("lo-LA")} ₭
              </span>
              <Button
                type="button"
                variant="secondary"
                disabled={isMarkPaidPending}
                onClick={onMarkPaid}
              >
                {isMarkPaidPending ? "ກຳລັງບັນທຶກ..." : "ໝາຍວ່າຈ່າຍແລ້ວ"}
              </Button>
            </>
          ) : workflowStep === "paid" && savedBatch ? (
            <span className="text-muted-foreground text-sm">
              ຈ່າຍແລ້ວ · {savedBatch.totalAmountKip.toLocaleString("lo-LA")} ₭ ·{" "}
              {savedBatch.instructorCount} ຄູ
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
